import { IconFileEmpty } from "@icons/index";
import { Trans } from "react-i18next";
export default ({ errorTip, blankTip }: { errorTip?: string; blankTip?: string }) => {
  return (
    <div className="Component-Section-NoResult">
      <IconFileEmpty className="w-[120px] h-[120px]" />
      <div className="text-kds-fg-subtle mt-[10px]">
        <Trans>{blankTip || "Nothing here yet."}</Trans>
      </div>
      <div className="errorTip">
        <Trans>{errorTip}</Trans>
      </div>
    </div>
  );
};
